import { fetchFromOldApi } from '~/services/Http';

export enum Roles {
  ALT_MANAGER = 'ALT_MANAGER',
  DEPUTY_MANAGER = 'DEPUTY_MANAGER',
  EMPLOYEE = 'EMPLOYEE',
  GUEST = 'GUEST',
  HR_INITIAL = 'HR_INITIAL',
  HR_ADMIN = 'HR_ADMIN',
  HR_ADMIN_LIMITED = 'HR_ADMIN_LIMITED',
  HR_AUDITOR = 'HR_AUDITOR',
  HR_DEV = 'HR_DEV',
  HR_SALARY = 'HR_SALARY',
  HR_STAFF = 'HR_STAFF',
  HR_PEOP = 'HR_PEOP',
  HR_PEOP_DEV = 'HR_PEOP_DEV',
  IT_ADMIN = 'IT_ADMIN',
  MANAGER = 'MANAGER',
  RECRUITER = 'RECRUITER',
  SUBSTITUTE_ABSENCE_MANAGER = 'SUBSTITUTE_ABSENCE_MANAGER',
}

//TODO: WHEN ROUTE WRAPPER IS DONE, THIS CAN BE REPLACED BY EMPLOYEE REDUX
export const getUserLastLogin = (username: string): Promise<string> =>
  fetchFromOldApi(`/json/user/${username}`)
    .then((r) => r.json())
    .then((r) => r.fLoginLastInfo.fLoginLastTimestamp);
